<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      meta: {
        title: '臺北市私立靜心高級中學',
        titleTemplate: '影音隨選系統',
        keyword: '影音平台,學習系統,隨選系統,vod,live',
        description: '靜心的每一天,累積孩子與世界接軌的能量',
        ogTitle: '臺北市私立靜心高級中學',
        ogDescription: '靜心的每一天,累積孩子與世界接軌的能量',
        ogType: 'website',
        //                    ogImage: this.baseURL+"/upload/convert_video_thumbnail/default.jpg",
        ogUrl: location.href,
        ogSite_name: '臺北市私立靜心高級中學'
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      titleTemplate: '%s - ' + this.meta.titleTemplate,
      meta: [
        { vmid: 'keywords', name: 'keywords', content: this.meta.keyword },
        { vmid: 'description', name: 'description', content: this.meta.description },
        { vmid: 'image', name: 'image', content: this.meta.ogImage },
        { vmid: 'og:title', property: 'og:title', content: this.meta.ogTitle, template: '%s - ' + this.meta.titleTemplate },
        { vmid: 'og:description', property: 'og:description', content: this.meta.ogDescription },
        { vmid: 'og:type', property: 'og:type', content: this.meta.ogType },
        { vmid: 'og:image', property: 'og:image', content: this.meta.ogImage },
        { vmid: 'og:url', property: 'og:url', content: this.meta.ogUrl },
        { vmid: 'og:site_name', property: 'og:site_name', content: this.meta.ogSite_name }
      ]
    }
  }
}
</script>
